import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section className="bg-brand-cream py-24 px-6" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <div className="bg-white rounded-[2.5rem] shadow-2xl p-8 md:p-16 border-4 border-brand-sage/20 relative overflow-hidden" data-id="element-153">
          {/* Discount Badge */}
          <div className="absolute top-0 right-0 bg-brand-red text-white font-bold py-2 px-12 transform translate-x-8 translate-y-6 rotate-45 shadow-md" data-id="element-154">
            50% OFF
          </div>

          <div className="text-center space-y-8" data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-black" data-id="element-156">
              Hoy accedés a TODO por:
            </h2>

            {/* Real Images Side by Side */}
            <div className="flex justify-center items-center gap-4 py-4" data-id="element-157">
              <img src="https://cdn.magicpatterns.com/uploads/a1ucxzbmvAv88ReZGGb89a/MOCKUP_EBOOK_PRIMEROS_PASOS.png" alt="Primeros Pasos" className="w-32 md:w-48 shadow-xl rounded-lg -rotate-6" data-id="element-158" />
              <span className="text-4xl font-bold text-brand-sage/30" data-id="element-159">+</span>
              <img src="https://cdn.magicpatterns.com/uploads/px3Xq7FZWG1G3tE7tj2UoM/MOCKUP_EBOOK_100_ACTIVIDADES.png" alt="100 Actividades y Juegos" className="w-32 md:w-48 shadow-xl rounded-lg rotate-6" data-id="element-160" />
            </div>

            <div className="flex flex-col items-center justify-center" data-id="element-161">
              <p className="text-brand-charcoal/60 font-bold text-xl mb-2" data-id="element-162">
                Valor Normal:{' '}
                <span className="line-through text-brand-red" data-id="element-163">$138.000</span>
              </p>
              <span className="text-6xl md:text-8xl font-black text-brand-sage tracking-tight drop-shadow-sm" data-id="element-164">
                $19.990
              </span>
              <div className="mt-4 bg-brand-red text-white font-bold px-6 py-2 rounded-full text-lg shadow-md animate-pulse" data-id="element-165">
                ¡AHORRÁS $118.010!
              </div>
              <div className="mt-4 bg-brand-sage/10 text-brand-sage font-medium px-6 py-2 rounded-full" data-id="element-166">
                Eso es menos que UN ebook. Y te llevás TODO el sistema completo.
              </div>
            </div>

            <div className="bg-brand-red/10 border-2 border-brand-red/30 rounded-xl p-5 max-w-md mx-auto shadow-inner" data-id="element-167">
              <p className="text-brand-red font-black flex items-center justify-center gap-2 text-lg" data-id="element-168">
                <span className="animate-bounce" data-id="element-169">⚠️</span> 50% OFF POR
                LANZAMIENTO
              </p>
              <p className="text-brand-red/90 font-medium mt-1" data-id="element-170">
                Este precio puede desaparecer en cualquier momento
              </p>
            </div>

            <div className="w-full max-w-sm mx-auto mt-6" data-id="element-171">
              <div className="flex justify-between text-sm font-bold text-brand-red mb-1" data-id="element-172">
                <span data-id="element-173">🔥 Alta demanda</span>
                <span data-id="element-174">Solo quedan 23 unidades</span>
              </div>
              <div className="w-full bg-brand-red/20 rounded-full h-3" data-id="element-175">
                <div className="bg-brand-red h-3 rounded-full" style={{
                width: '87%'
              }} data-id="element-176"></div>
              </div>
              <p className="text-xs text-center text-brand-charcoal/60 mt-2 font-medium" data-id="element-177">
                87% vendido a este precio
              </p>
            </div>

            <div className="pt-4" data-id="element-178">
              <CTAButton className="w-full md:w-auto md:px-12 md:py-5 text-xl" data-id="element-179" />
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap justify-center gap-6 pt-8 border-t border-brand-sage/10" data-id="element-180">
              <div className="flex items-center gap-2 text-brand-charcoal/60 text-sm font-medium" data-id="element-181">
                <Lock className="w-4 h-4" data-id="element-182" />
                <span data-id="element-183">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-2 text-brand-charcoal/60 text-sm font-medium" data-id="element-184">
                <ShieldCheck className="w-4 h-4" data-id="element-185" />
                <span data-id="element-186">Garantía de 30 días</span>
              </div>
              <div className="flex items-center gap-2 text-brand-charcoal/60 text-sm font-medium" data-id="element-187">
                <CreditCard className="w-4 h-4" data-id="element-188" />
                <span data-id="element-189">Todos los medios de pago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}